import client from "./client";

const getData = async (options) => {
    return client.get("/tvAnalytics/", options);
};

export { getData };